import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { deleteContract, getContracts } from '../../../../../api/endpoints/cmsSite';
import type { Contract } from '../../../../../api/types/cmsSite';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';
import {
  ListPageScaffold,
  RowActions,
  useDeleteResource,
  type DataTableColumn,
} from '../../../../../components/common';
import { ContractFormDialog } from '../ContractFormDialog';

export default function ContractListPage({ siteId }: { siteId: number }) {
  const [createOpen, setCreateOpen] = useState(false);
  const [editing, setEditing] = useState<Contract | null>(null);

  const query = useQuery({ queryKey: ['cms', 'contracts', siteId], queryFn: () => getContracts(siteId) });
  const rows: Contract[] = useMemo(() => query.data?.contracts ?? [], [query.data]);

  const del = useDeleteResource<number>({
    mutationFn: (id) => deleteContract(id),
    invalidateKeys: [['cms', 'contracts']],
    successMessage: 'Sözleşme silindi.',
  });

  const columns: DataTableColumn<Contract>[] = [
    { id: 'title', header: 'Başlık', cell: (r) => r.title ?? '—' },
    { id: 'type', header: 'Tip', cell: (r) => r.type ?? '—' },
  ];

  return (
    <ListPageScaffold
      title="Sözleşmeler"
      headerVariant="section"
      createLabel="Yeni Sözleşme"
      onCreate={() => setCreateOpen(true)}
      query={query}
      rows={rows}
      columns={columns}
      getRowKey={(r) => r.id}
      emptyTitle="Kayıtlı sözleşme bulunamadı."
      rowActions={(r) => <RowActions onEdit={() => setEditing(r)} onDelete={() => del.request(r.id)} />}
    >
      <ContractFormDialog open={createOpen} contract={null} siteId={siteId} onClose={() => setCreateOpen(false)} />
      <ContractFormDialog open={!!editing} contract={editing} siteId={siteId} onClose={() => setEditing(null)} />
      <ConfirmDialog
        {...del.confirmDialogProps}
        title="Sözleşmeyi sil"
        description="Bu sözleşmeyi silmek istediğinize emin misiniz?"
      />
    </ListPageScaffold>
  );
}
